module.exports = __webpack_public_path__ + "static/media/git_logo.5dad0112.jpg";